import React, { useCallback, useEffect, useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import html2canvas from "html2canvas";

const DownloadPlayerCard = (props) => {
  const brandingDetails = JSON.parse(localStorage.getItem("branding") || "{}");
  const clubDetails = JSON.parse(localStorage.getItem("club_details") || "{}");
  const modalContentRef = useRef(null); // Ref for modal content

  // Capture the modal content as an image and download it
  const captureImage = () => {
    const targetElement = modalContentRef.current;
    if (modalContentRef.current) {
      html2canvas(targetElement, { useCORS: true }).then((canvas) => {
        const image = canvas.toDataURL("image/png");

        // Create a download link
        const downloadLink = document.createElement("a");
        downloadLink.href = image;
        downloadLink.download = `MyClubtap-${props.playerCardData?.full_name}`;

        // Append the link to the document and trigger a click event
        document.body.appendChild(downloadLink);
        downloadLink.click();

        // Remove the link from the document
        document.body.removeChild(downloadLink);
      });
    }
  };

  const handleModalEntered = useCallback(() => {
    const timeout = setTimeout(() => {
      captureImage();
      props.handlePlayerDownloadCardClose();
    }, 2000);
    return () => clearTimeout(timeout); // Cleanup the timeout
  }, [captureImage]);

  return (
    <Modal
      show={props.show}
      onHide={props.handlePlayerDownloadCardClose}
      onEntered={handleModalEntered} // Triggered when the modal fully opens
      id="playermoreinfo"
      size="lg"
    >
      <div ref={modalContentRef}>
        {/* Modal Content */}
        <div className="player_star_info">
          <div className="player_star_pic">
            <Link
              className="player_profile_url"
              to={`/player-profile/${props.playerCardData?.id}`}
            >
              <figure>
                {props.playerCardData?.is_avatar === 1 ? (
                  <img
                    src={`${process.env.REACT_APP_PLAYER_AVATAR_URL}${props.playerCardData.image}`}
                    alt="Player Avatar"
                  />
                ) : (
                  <img
                    src={`${process.env.REACT_APP_UPLOAD_URL}player/${props.playerCardData?.image}`}
                    alt="Player Imageasdasdas"
                  />
                )}
              </figure>
            </Link>
            <div className="player_description">
              <h3>{props.playerCardData?.full_name}</h3>
              <div className="player_game_name">
                {props.playerCardData?.position === 4 && (
                  <span>Wicket-Keeper</span>
                )}
                {props.playerCardData?.position === 1 && <span>Batter</span>}
                {props.playerCardData?.position === 3 && (
                  <span>All-Rounder</span>
                )}
                {props.playerCardData?.position === 2 && <span>Bowler</span>}
                ,&nbsp; {props.playerTeamName}
              </div>
              <div className="player_game_name">{clubDetails?.game_name}</div>
              <div className="player_game_name">
                Views: {props.playerProfileView || 0}
              </div>
            </div>
          </div>
          <div className="club_logo">
            <figure>
              {props.playerSponsor?.logo ? (
                <img
                  src={`${process.env.REACT_APP_UPLOAD_URL}sponsor/${props.playerSponsor.logo}`}
                  alt="Sponsor Logo"
                />
              ) : brandingDetails?.logo ? (
                <img
                  src={`${process.env.REACT_APP_UPLOAD_URL}branding/${brandingDetails.logo}`}
                  alt="Brand Logo"
                />
              ) : (
                <img
                  src={`../images/small-brand-logo.jpg`}
                  alt="Default Logo"
                />
              )}
            </figure>
          </div>
        </div>

        {/* Player Stats */}
        <ul className="game_progress_info">
          <li>
            <div className="progress_info">
              Fantasy Pts
              <strong>{props.playerCardModalData?.sum_fp ?? "-"}</strong>
            </div>
          </li>
          <li>
            <div className="progress_info">
              Fantasy Value
              <strong>
                {props.club_details?.default_salary_symbol}
                {props.playerCardData?.svalue}
                {props.club_details?.default_salary_symbol ? "m" : ""}
              </strong>
            </div>
          </li>
          <li>
            <div className="progress_info">
              Value Change
              <strong>
                {props.playerCardModalData?.valueChangeAvg
                  ?.value_change_in_percent >= 0
                  ? `+${props.playerCardModalData?.valueChangeAvg?.value_change_in_percent}`
                  : props.playerCardModalData?.valueChangeAvg
                      ?.value_change_in_percent}
                %
              </strong>
            </div>
          </li>
          <li>
            <div className="progress_info">
              Picked in Teams
              {props.userPaidForClub === 1 ? (
                <strong>{Math.round(props.playerSelected)}%</strong>
              ) : (
                <Link
                  className="lock-img"
                  onClick={(event) => {
                    event.preventDefault();
                    props.handleGamePassModalShow();
                  }}
                >
                  <img src="../images/lock-icon.png" alt="Lock Icon" />
                </Link>
              )}
            </div>
          </li>
          <li>
            <div className="progress_info">
              Avg Points
              <strong>{props.playerCardModalData?.avgPoints ?? "-"}</strong>
            </div>
          </li>
          <li>
            <div className="progress_info">
              Best Score
              <strong>{props.playerCardModalData?.bestScore ?? "-"}</strong>
            </div>
          </li>
        </ul>
        <div className="player-performance">
          <ul>
            <li>
              <div className="performancebox">
                Matches
                <strong>{props.playerCardModalData?.tot_match ?? ""}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Innings
                <strong>{props.playerCardModalData?.inning ?? "-"}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Runs<strong>{props.playerCardModalData?.sum_rs}</strong>
              </div>
            </li>
            {clubDetails?.game_type === 3 && (
              <>
                <li>
                  <div className="performancebox">
                    Ones
                    <strong>
                      {props.playerCardModalData?.sum_ones ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Twos
                    <strong>
                      {props.playerCardModalData?.sum_twos ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Threes
                    <strong>
                      {props.playerCardModalData?.sum_threes ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Fours
                    <strong>
                      {props.playerCardModalData?.sum_fours ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Fives
                    <strong>
                      {props.playerCardModalData?.sum_fives ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Sixes
                    <strong>
                      {props.playerCardModalData?.sum_sixes ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Sevens
                    <strong>
                      {props.playerCardModalData?.sum_sevens ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Eights
                    <strong>
                      {props.playerCardModalData?.sum_eights ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Nines
                    <strong>
                      {props.playerCardModalData?.sum_nines ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Outs
                    <strong>
                      {props.playerCardModalData?.sum_outs ?? "-"}
                    </strong>
                  </div>
                </li>
              </>
            )}
            {clubDetails?.game_type !== 3 && (
              <>
                <li>
                  <div className="performancebox">
                    Fours
                    <strong>
                      {props.playerCardModalData?.sum_fours ?? "-"}
                    </strong>
                  </div>
                </li>
                <li>
                  <div className="performancebox">
                    Sixes
                    <strong>
                      {props.playerCardModalData?.sum_sixes ?? "-"}
                    </strong>
                  </div>
                </li>
              </>
            )}

            <li>
              <div className="performancebox">
                Ducks
                <strong>{props.playerCardModalData?.sum_dks ?? "-"}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Overs{" "}
                <strong>{props.playerCardModalData?.sum_overs ?? "-"}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Maidens
                <strong>{props.playerCardModalData?.sum_mdns ?? "-"}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Runs Given
                <strong>{props.playerCardModalData?.sum_rg ?? "-"}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Wickets
                <strong>{props.playerCardModalData?.sum_wks ?? "-"}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Hat-trick
                <strong>
                  {props.playerCardModalData?.sum_hattrick ?? "-"}
                </strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Catches
                <strong>{props.playerCardModalData?.sum_cs ?? "-"}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Catches WK
                <strong>{props.playerCardModalData?.sum_cwk ?? "-"}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                Stumpings
                <strong>{props.playerCardModalData?.sum_sts ?? "-"}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                RO Direct
                <strong>{props.playerCardModalData?.sum_rods ?? "-"}</strong>
              </div>
            </li>
            <li>
              <div className="performancebox">
                RO Assist
                <strong>{props.playerCardModalData?.sum_roas ?? "-"}</strong>
              </div>
            </li>
          </ul>
          {props.playerSponsor?.name && (
            <div
              className="countdata"
              style={{
                backgroundColor: "#FFD43C",
                width: "100%",
                margin: "0px",
                padding: "7px 0px 1px",
              }}
            >
              <div className="gameweek-filter">
                <h4
                  style={{
                    color: "black",
                    fontSize: "16px",
                    fontWeight: "500",
                  }}
                >
                  Sponsor: {props.playerSponsor?.name}
                </h4>
              </div>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default DownloadPlayerCard;
